import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-6 md:px-10 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="font-heading text-xl text-background-50 mb-4 block">
                Sugargoo<span className="text-primary-400">Spreadsheet</span>
              </Link>
              <p className="text-sm text-background-50/60 leading-relaxed">
                Your independent resource for Sugargoo shopping guides, product spreadsheets, shipping cost analysis, and expert reviews.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-sm text-background-50 mb-4">Quick Links</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Home</Link>
                <Link to="/sugargoo-spreadsheet-complete-guide" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Complete Guide</Link>
                <a href="#categories" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Categories</a>
                <a href="#guides" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Guides</a>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-sm text-background-50 mb-4">Resources</h4>
              <div className="flex flex-col gap-2.5">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Main Website</a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Shop Now</a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Browse Products</a>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-sm text-background-50 mb-4">Legal</h4>
              <div className="flex flex-col gap-2.5">
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Privacy Policy</a>
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Terms of Service</a>
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Affiliate Disclosure</a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; 2026 SugargooSpreadsheet.wiki. All rights reserved. We are an independent informational website and are not affiliated with Sugargoo.
            </p>
            <p className="text-xs text-background-50/40">
              All external links open in new tabs.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}